import Client from '../infra/http/AxiosClient';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);

  const base64 = (base64String + padding)
      // eslint-disable-next-line
      .replace(/\-/g, '+')
      // eslint-disable-next-line
      .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function checkBrowserSuport() {
  if (!('serviceWorker' in navigator))
    return false;

  if (!('PushManager' in window))
    return false;

  return true;
}

export function registerServiceWorker() {
  if(!checkBrowserSuport())
    return undefined;

  return navigator
         .serviceWorker
         .register('/sw.js')
         .then(function(registration) {
            return registration;
         })
         .catch(function(err) {
            console.error('Unable to register service worker.', err);
            return undefined;
         });
}

export function subscribeUserToPush(registration) {
  const subscribeOptions = {
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_PUBLICVAPIDKEY)
  };
  const previousSubscription = registration.pushManager.getSubscription();
  previousSubscription.then(subscription => {
    if(subscription===null){
      const newSubscription = registration.pushManager.subscribe(subscribeOptions);
      const result = newSubscription.then(resolve => sendSubscriptionToBackEnd(resolve));
      return result;
    } else {
      return subscription;
    }
  });
}

export function sendSubscriptionToBackEnd(subscription) {
  const result = Client.post(`${process.env.REACT_APP_API}/push/subscribe`, {subscription: JSON.stringify(subscription)});
  return result
  .then(function(response) {
    return response;
  })
  .catch(error => console.log(error));
}

export function startPushNotificationService() {
  try{
    const pushNotificationSW = registerServiceWorker();
    if(pushNotificationSW){
      const result = pushNotificationSW.then( resolve => subscribeUserToPush(resolve) );
      return result;
    } else{
      console.log('Service Workers are not supported');
      return undefined;
    }
  } catch(error) {
    console.log('Error while subscribing to service workers', error);
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/services/PushNotificationService.js